export default __webpack_public_path__ + "static/media/googleplay.e829c92d.png";